export default __webpack_public_path__ + "static/assets/images/aabef071dba234be7a35c8f7e1871001.svg";